@if (!isMobileWebView) {
  <header class="registration-header-top-row">
    <img
      alt="Cariloop Logo"
      class="cariloop-logo"
      src="assets/icon/Cariloop-Logo-Black.svg"
    />
    <lib-lang-dropdown
      (itemSelectedChange)="changeLanguage($event.value)"
      [languages]="languages"
      [itemSelected]="browserLanguage ? browserLanguage : fallbackLanguage"
    />
    <ng-content select="[slot-logo-or-counter]" />
  </header>
}
<main class="sso-error-content">
  <h1>{{ "REGISTER.SSO_ERROR.TITLE" | translate }}</h1>
  <div class="banner">
    <p class="text">
      <b style="font-weight: 600">
        {{ "REGISTER.SSO_ERROR.DESCRIPTION_PART_1" | translate }}
      </b>
      {{ "REGISTER.SSO_ERROR.DESCRIPTION_PART_2" | translate }}
    </p>
  </div>
</main>

<!-- https://local-plan.cariloop.com/register/sso-error -->
